import Keycloak from "keycloak-js";

const KEY_CLOAK_URL = "https://gilead-auth.indegene.com/auth";
const CLIENT_ID = "NCCA";
const REALM = "NCCA-GILEAD-PROD";

export const keycloak = new Keycloak({
  url: KEY_CLOAK_URL,
  realm: REALM,
  clientId: CLIENT_ID,
});

let isExplicitLogout = false;
export const markExplicitLogout = () => {
  isExplicitLogout = true;
};

export const tokenLogger = async (tokenData) => {
  if (!tokenData.token) return;
  const existingToken = window.localStorage.getItem("userToken");
  // Only update if token actually changed
  if (existingToken === tokenData.token) return;
  window.localStorage.setItem("userToken", tokenData.token);
  window.localStorage.setItem("bearerToken", tokenData.token);
  const data = await keycloak.loadUserInfo();
  window.localStorage.setItem(
    "userRole",
    JSON.stringify(keycloak.realmAccess?.roles || []),
  );
  window.localStorage.setItem("userEmail", data.email);
  window.localStorage.setItem("userId", data.sub);
  window.localStorage.setItem("currentUserName", data.name);
};

export const eventLogger = async (event) => {
  if (event === "onAuthLogout") {
    window.location.href = `https://contentstudio.gilead.com`;
  }
};

export const logoutUser = async () => {
  isExplicitLogout = true;
  await keycloak.logout({
    redirectUri: "https://contentstudio.gilead.com",
  });
};
